import Vue from 'vue';
import {
    DatePicker, 
    Loading,
    MessageBox,
    Message,
    Notification,
    Dialog,
    Scrollbar
} from 'element-ui';

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

export function elementui() {
    Vue.use(Loading.directive);
    Vue.use(DatePicker);
    Vue.use(Dialog);
    Vue.use(Scrollbar);
}